<template>
  <el-card>
    <el-row class="common-margin">
      <el-row>
        <el-col :span="12">
          <el-button type="primary" icon="el-icon-folder" size="small" @click="add">可选产品</el-button>
        </el-col>
      </el-row>
      <el-table
          :data="tableData"
          :max-height="tableHeight"
          style="width: 100%; margin-bottom: 20px; margin-top: 20px"
          border
      >
        <el-table-column type="index" width="80px" align="center" label="序号"> </el-table-column>
        <el-table-column prop="companyName" align="center" label="公司名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="productName" align="center" label="产品名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="logo" align="center" label="图片" width="140">
          <template slot-scope="scope">
            <el-image
                v-if="scope.row.logo"
                style="height: 100px;"
                :src="scope.row.logo"
                :preview-src-list="scope.row.logoList"
                fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column prop="status" align="center" label="状态"></el-table-column>
      </el-table>
      <el-pagination :current-page.sync="currentPage" :page-size="pageSize" layout="total" :total="total">
      </el-pagination>
    </el-row>
  </el-card>
</template>

<script>

export default {
  name: 'meetBrandProductIndex',
  data () {
    return {
      tableData: [],
      tableHeight: 0,
      currentPage: 1,
      pageSize: 100,
      total: 0,
      recordId: ''
    }
  },
  created () {
    this.tableHeight = document.documentElement.clientHeight - 540
  },
  methods: {
    async getPageList (id) {
      this.recordId = id
      this.tableData = []
      let {data: res} = await this.$http.post('/meetBrandProduct/getList', {
        recordId: this.recordId,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      })
      console.log(res)
      if (res.code === '200') {
        this.tableData = res.data || []
        this.tableData.forEach(item => {
          if (item.logo) {
            item.logoList = item.logo.split(',')
            item.logo = item.logo.split(',')[0]
          } else {
            item.logo = ''
            item.logoList = []
          }
        })
        this.total = this.tableData.length
      } else {
        this.$message.error(res.msg)
      }
    },
    add () {
      this.$emit('isShowActivity')
    },
    // 分页
    handleCurrentChange (page) {
      this.currentPage = page
      this.getPageList(this.recordId)
    },
    handleSizeChange (size) {
      this.pageSize = size
      this.getPageList(this.recordId)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/meetSession/meetBrandProduct.vue